<template>
<v-flex>
  <v-layout>
    <v-flex xs7>
      <v-text-field type="text" :label="`${index +1}) ${label}`" :value="data.name" :rules="nameRules" @change="update({name: $event})" />
    </v-flex>
    <v-flex xs1>
      <v-dialog width="500" v-model="valuesDialog">
        <v-btn fab small dark color="cyan" slot="activator">
          <v-icon>check_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-card-title class="headline" primary-title>
            {{ label }} - {{ $t('schema.builder.values') }}
          </v-card-title>
          <v-divider />
          <component :is="this.data.type + '-values'" :id="this.data.id" :values="this.data.values" @update="this.setValues"></component>
          <v-divider />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="valuesDialog = false">
              {{ $t('base.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <description :fieldName="data.name" :description="data.description" :small="true" @updateImages="updateOptions" @update="updateDescription($event)"></description>
    </v-flex>
    <v-flex xs1>
      <v-dialog width="500" v-model="optionsDialog">
        <v-btn small fab dark color="indigo" slot="activator">
          <v-icon>settings</v-icon>
        </v-btn>
        <v-card>
          <v-card-title class="headline" primary-title>
            {{ $t('schema.builder.options-label', { label }) }}
          </v-card-title>
          <v-divider />
          <component :is="this.data.type + '-options'" :id="this.data.id" :options="this.data.options" :context="context" @update="this.updateOptions"></component>
          <v-divider />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="optionsDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <v-btn small fab dark color="warning" @click="destroy">
        <v-icon>delete_forever</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</v-flex>
</template>

<script>
import FormuleOptions from './options/FormuleOptions'
import FormuleValues from './values/FormuleValues'
import RadioOptions from './options/RadioOptions'
import RadioValues from './values/RadioValues'
import subField from '@/mixins/subField'
import Description from './Description'
import field from '@/mixins/field'
import CheckboxOptions from './options/CheckboxOptions'
import CheckboxValues from './values/CheckboxValues'

export default {
  name: "predefined-sub-field",
  components: {
    Description,
    "radio-options": RadioOptions,
    "radio-values": RadioValues,
    "formule-options": FormuleOptions,
    "formule-values": FormuleValues,
    "checkbox-options": CheckboxOptions,
    "checkbox-values": CheckboxValues
  },
  mixins: [subField, field],
  data() {
    return {
      valuesDialog: false,
      optionsDialog: false
    }
  },
  computed: {
    label() {
      switch (this.data.type) {
      case 'radio':
        return this.$t('schema.builder.inputs.radio-field')
      case 'formule':
        return this.$t('schema.builder.inputs.formule-field')
      case 'checkbox':
        return this.$t('schema.builder.inputs.checkbox-field')
      }
    }
  },
  methods: {
    setValues(payload) {
      payload['id'] = this.data.id
      this.$store.commit("setSubFieldValues", payload)
    },
    updateDescription(description) {
      let payload = {
        id: this.data.id,
        description
      }
      this.$store.commit("updateSubFieldDescription", payload)
    }
  }
}
</script>
